export const TIDYCAL_URLS = {
  sessie: "https://tidycal.com/stijnswinnen/2800love",
  owner: "https://tidycal.com/stijnswinnen/je-favoriete-plek",
} as const;
